<template>
    <Toast/>
    <div class="pt-4 pb-2">
        <div v-if="$can('view','card')" class="flex justify-content-between align-items-end">
            <h1 class="my-auto"> Cards </h1>
            <div v-if="$can('add','card')" class="card p-1">
                <Button data-cy="new_card_button" class="p-button-text p-button-success" @click="openModal" v-tooltip.bottom="'New Card'">
                    <i class="pi pi-plus" style="font-size: 1.5rem" ></i>
                </Button>
            </div>
        </div>  

        <Dialog data-cy="new_card_modal" header="New Card" v-model:visible="displayModal" :modal="true" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}">
            <form id="form_new_card" @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid">
                <div class="container">
                    <div class="row justify-content-center pt-3">
                        <div class="col-10 md:col-12">
                            <div class="p-float-label">
                                <InputText id="name" v-model="v$.name.$model" :class="{'p-invalid':v$.name.$invalid && submitted || card_errors.name}" />
                                <label for="name" :class="{'p-error':v$.name.$invalid && submitted}"> Name* </label>
                                <small v-if="Object.keys(card_errors).length !== 0 && card_errors.name" class="p-error"><span v-for="error in card_errors.name" :key="error">{{error}}<br></span></small>
                            </div>
                            <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{v$.name.required.$message.replace('Value', 'Name')}}</small>
                        </div>        
                    </div>
                    <div class="row justify-content-center pt-3">
                        <div class="col-10 md:col-12">
                            <div class="p-float-label">
                                <InputText id="number" v-model="v$.number.$model" :class="{'p-invalid':v$.number.$invalid && submitted || card_errors.number}"/>
                                <label for="number" :class="{'p-error':v$.number.$invalid && submitted}"> Number </label>
                                <small v-if="Object.keys(card_errors).length !== 0 && card_errors.number" class="p-error"><span v-for="error in card_errors.number" :key="error">{{error}}<br></span></small>
                            </div>
                            <small v-if="(v$.number.$invalid && submitted) || v$.number.$pending.$response" class="p-error">{{v$.number.required.$message.replace('Value', 'Number')}}</small>
                        </div>        
                    </div>
                    <div class="row justify-content-center pt-3">
                        <div class="col-10 md:col-12">
                            <div class="p-float-label">
                                <InputNumber id="balance" v-model="balance"/>
                                <label for="balance"> Balance </label>
                                <small v-if="Object.keys(card_errors).length !== 0 && card_errors.balance" class="p-error"><span v-for="error in card_errors.balance" :key="error">{{error}}<br></span></small>
                            </div>
                        </div>        
                    </div>
                    <div class="row justify-content-center pt-3">
                        <div class="col-10 md:col-12">
                            <div class="p-float-label">
                                <InputText id="bank" v-model="bank"/>
                                <label for="bank"> Bank </label>
                                <small v-if="Object.keys(card_errors).length !== 0 && card_errors.bank" class="p-error"><span v-for="error in card_errors.bank" :key="error">{{error}}<br></span></small>
                            </div>
                        </div>        
                    </div>
                    <div class="row justify-content-center pt-3">
                        <div class="col-10 md:col-12">
                            <div class="p-float-label">
                                <Dropdown data-cy="users_dropdown" id="id_group" v-model="v$.id_user_assigned.$model" :options="get_all_users" optionLabel="username" optionValue="id" :filter="true" :class="{'p-invalid':v$.id_user_assigned.$invalid && submitted || card_errors.id_user_assigned}"/>
                                <label for="id_group" :class="{'p-error':v$.id_user_assigned.$invalid && submitted || card_errors.id_user_assigned}"> User* </label>
                                <small v-if="Object.keys(card_errors).length !== 0 && card_errors.id_user_assigned" class="p-error"><span v-for="error in card_errors.id_user_assigned" :key="error">{{error}}<br></span></small>
                            </div>
                            <small v-if="(v$.id_user_assigned.$invalid && submitted) || v$.id_user_assigned.$pending.$response" class="p-error">{{v$.id_user_assigned.required.$message.replace('Value', 'User')}}</small>
                        </div>
                    </div>
                </div>
            </form>
            <template #footer>
                <Button data-cy="create_card_button" form="form_new_card" type="submit" label="Submit" class="p-button-raised"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Toast from 'primevue/toast'
import Dropdown from 'primevue/dropdown'
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core"

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        Dialog,
        Button,
        InputText,
        InputNumber,
        Toast,
        Dropdown
    },
    data() {
        return {
            displayModal: false,
            name: '',
            number: '',
            bank: '',
            balance: 0,
            id_user_assigned: null,
            card_errors:{},
            submitted: false,
            showMessage: false,
        }
    },
    created() {
        this.$store.dispatch('load_all_users')
    },
    computed: {
        get_cards: function() {
            return this.$store.getters.get_cards
        },
        get_card_errors: function() {
            return this.$store.getters.get_card_errors
        },
        get_all_users: function() {
            return this.$store.getters.get_all_users
        }
    },
    methods: {
        openModal() {
            this.displayModal = true;
        },
        closeModal() {
            this.displayModal = false;
        },
        async add_card() {
            let card = { 
                name: this.name,
                number: this.number,
                balance: this.balance,
                bank: this.bank,
                id_user_assigned: this.id_user_assigned
            }
            await this.$store.dispatch('create_card', card)
            this.card_errors = this.get_card_errors
            if(Object.keys(this.card_errors).length === 0){
                this.toggleDialog();
                this.name = ''
                this.number = ''
                this.bank = ''
                this.balance = 0
                this.id_user_assigned = ''
                this.submitted = false;
                return true
            }
            return false
        },
        async handleSubmit(isFormValid) {

            this.submitted = true;
            
            if (!isFormValid) {
                return;
            }

            let res = await this.add_card()
            if (res){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Card added', life: 3000});
            } 
        },
        toggleDialog() {
            this.showMessage = !this.showMessage;
            this.closeModal()

            if(!this.showMessage) {
                this.resetForm();
            }
        },
        resetForm() {
            this.name = '';
            this.number = '';
            this.bank = '';
            this.id_user_assigned = '';
            this.submitted = false;
        }
    },
    validations() {
        return {
            name: { required },
            number: { required },
            id_user_assigned: { required }
        }
    },
};
</script>

<style scoped>
</style>